export default "__VITE_ASSET__BShMziC7__"